export default __webpack_public_path__ + "static/media/10.29ec0ef9.png";